import moment from 'moment';
import { ORDER_MAPPING, POSITION_MAPPING } from '../constants';

/**
 * Maps raw position data to Position objects
 * @param data Array of raw position data
 * @returns Array of Position objects
 */
export const mapPosition = (data = []) => {
  if (!data?.length) return [];

  return data.map((item) => ({
    position: item[POSITION_MAPPING.position - 1],
    symbol: item[POSITION_MAPPING.symbol - 1],
    action: item[POSITION_MAPPING.action - 1] ?? 0,
    digits: item[POSITION_MAPPING.digits - 1],
    digitsCurrency: item[POSITION_MAPPING.time_update - 1],
    contractSize: item[POSITION_MAPPING.contract_size - 1],
    timeCreate: item[POSITION_MAPPING.time_create - 1],
    timeExpiration: item[POSITION_MAPPING.time_create - 1],
    timeUpdate: item[POSITION_MAPPING.time_update - 1],
    priceOpen: item[POSITION_MAPPING.price_open - 1],
    priceCurrent: item[POSITION_MAPPING.price_current - 1],
    priceSL: item[POSITION_MAPPING.price_sl - 1] ?? 0,
    priceTP: item[POSITION_MAPPING.price_tp - 1] ?? 0,
    volume: item[POSITION_MAPPING.volume - 1],
    profit: item[POSITION_MAPPING.profit - 1] ?? 0,
    reason: item[POSITION_MAPPING.reason - 1] ?? '',
    rateProfit: item[POSITION_MAPPING.rate_profit - 1],
    swap: item[POSITION_MAPPING.swap - 1] ?? 0
  }));
};

/**
 * Maps raw order data to Order objects
 * @param data Array of raw order data
 * @returns Array of Order objects
 */

const mapExpirationTimeDisplay = (time) => {
  // Early return for zero time
  if (!time) {
    return { d: null, t: null, type: 0 };
  }

  // Convert unix timestamp to UTC moment object once
  const timeUtc = moment.unix(time).utc();
  const dateStr = timeUtc.format('YYYY-MM-DD');
  const timeStr = timeUtc.format('HH:mm:ss');
  const today = moment.utc().format('YYYY-MM-DD');

  // Base response object
  const response = { d: dateStr, t: timeStr };

  // Determine type based on conditions
  if (moment(dateStr).isSame(today) && timeStr === '00:00:00') {
    return { ...response, type: 1 }; // Same day
  }

  if (timeStr === '00:00:00') {
    return { ...response, type: 3 }; // Midnight exactly
  }

  return { ...response, type: 2 }; // Different day with specific time
};

export const mapOrder = (data = []) => {
  if (!data?.length) return [];

  return data.map((element) => ({
    positionId: element[ORDER_MAPPING.position_id] ?? 0,
    order: element[ORDER_MAPPING.order] ?? 0,
    symbol: element[ORDER_MAPPING.symbol - 1] ?? '',
    digits: element[ORDER_MAPPING.digits - 1] ?? 0,
    timeCreate: element[ORDER_MAPPING.time_setup - 1] ?? 0,
    time_expiration: element[ORDER_MAPPING.time_expiration - 1] ?? 0,
    type_time: element[ORDER_MAPPING.type_time - 1] ?? mapExpirationTimeDisplay(element[ORDER_MAPPING.time_expiration - 1]).type,
    digisCurrency: element[ORDER_MAPPING.digis_currency - 1] ?? 0,
    contractSize: element[ORDER_MAPPING.contract_size - 1] ?? 0,
    type: element[ORDER_MAPPING.type - 1] ?? 0,
    priceOrder: element[ORDER_MAPPING.price_order - 1] ?? 0,
    priceTrigger: element[ORDER_MAPPING.price_trigger - 1] ?? 0,
    priceSL: element[ORDER_MAPPING.price_sl - 1] ?? 0,
    priceTP: element[ORDER_MAPPING.price_tp - 1] ?? 0,
    volumeInitial: element[ORDER_MAPPING.reason - 1] ?? 0,
    volumeCurrent: element[ORDER_MAPPING.volume_current - 1] | null,
    comment: element[ORDER_MAPPING.comment - 1] ?? 'No Comment'
  }));
};
